import { render, staticRenderFns } from "./Events_Products.vue?vue&type=template&id=58d1974e&scoped=true&"
import script from "./Events_Products.vue?vue&type=script&lang=js&"
export * from "./Events_Products.vue?vue&type=script&lang=js&"
import style0 from "./Events_Products.vue?vue&type=style&index=0&id=58d1974e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d1974e",
  null
  
)

export default component.exports